{ isValidEvent } = require("../../../utils/messaging")

complete = (data, done) ->
  Application.publish("event:completed") {}

open = ->

exit = ->

commands = (next) -> { complete, open, exit }

receiveMessage = (event) ->
  build_platform = window.build_platform or "browser"
  return if not isValidEvent(event) and build_platform != 'scorm' # allow any origin for exported SCORM
  commands = event.data
  try
    eval commands
  catch err
    # console.error "Could not execute command", commands, err

window.addEventListener("message", receiveMessage, false)
opener = window.opener or window.parent
opener?.postMessage "Backbone.Events.trigger('lesson-ready');", '*'

module.exports = { type: "lesson", commands }
